import { connect } from 'react-redux';

import FacebookEmbed from './FacebookEmbed';
import { fieldChange, toggleFacebookOption } from './actions';

const mapStateToProps = (state, ownProps) => ownProps;

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (field, value) =>
    dispatch(
      fieldChange(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        field,
        value,
      ),
    ),
  onToggle: (field, value) =>
    dispatch(
      toggleFacebookOption(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        field,
        value,
      ),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FacebookEmbed);
